import axios from 'axios'
import { getAPIService } from '../../../getServerHost'

export const deleteGroup = async (payload: number) => {
  const response = await axios.delete(`${getAPIService}/groups/${payload}`)
  return response.data
}
